import { GoldMaster } from '../../references/tenant';
import { CacheService } from '../../services/cache-service';
import tenantService from '../../services/tenant-service';
import { RecordStatus } from '../../types/record-status';
import { Icons } from '../icons/icons';
import moment from 'moment';
import React from 'react';

export type ManuallyAddedColumnType = {
  accessor: string;
  Header: string;
  width: number;
  sort: boolean;
  Cell: (item: any) => void;
};

export const ManuallyAddedColumn = (): ManuallyAddedColumnType  => {
  return {
    accessor: 'recordStatus',
    Header: 'Manually Added',
    width: 164,
    sort: true,
    Cell: (item: any): JSX.Element => item.row.original.recordStatus === RecordStatus.MANUAL_ADD
      ? <Icons.Selected />
      : <span />  };
};

export type GearIconColumnType = {
  accessor: string;
  Header: string;
  sort: boolean;
  width: number;
  maxWidth: number;
  minWidth: number;
  Cell: (item: any) => void;
};

export const GearIconColumn = (): GearIconColumnType[] | [] => {
  if (CacheService.get('pdc.tenant.id') === GoldMaster) {
    return [];
  }
  return [{
    accessor: 'locked',
    Header: '',
    sort: true,
    width: 29,
    maxWidth: 29,
    minWidth: 29,
    Cell: (item: any): JSX.Element => {
      if (item.row.original.recordStatus === 'GM_EDITED') {
        return <Icons.Gear />;
      }
      return <></>;
    }
  }];
};

export type ActionColumnType = {
  accessor: string;
  Header: string;
  width: number;
  maxWidth: number;
  minWidth: number;
  sort: false;
  Cell: (item: any) => JSX.Element;
};

export type Props = {
  onAdd?: (item: any) => void;
  onUpdate?: (item: any) => void;
  onDelete?: (item: any) => void;
  onExport?: (item: any) => void;
};

export const ActionColumn = (props?: Props): ActionColumnType => {
  return {
    accessor: 'actions',
    Header: '',
    width: 150,
    maxWidth: 150,
    minWidth: 150,
    sort: false,
    Cell: (item: any): JSX.Element => {
      const className = item.row.original.recordStatus === RecordStatus.GM_LOCKED && CacheService.get('pdc.tenant.id') !== GoldMaster ? 'invisible' : '';
      return (
        <div role="cell" className="body-cell new-td new-td-action">
          {typeof props?.onAdd === 'function' && (
            <span onClick={(): void => props?.onAdd?.(item.row.original)} className={className}>
              <Icons.Add className="pointer row-action" />
            </span>
          )}
          {typeof props?.onExport === 'function' && (
            <span onClick={(): void => props?.onExport?.(item.row.original)} className={className}>
              <Icons.Export className="pointer row-action" />
            </span>
          )}
          {typeof props?.onUpdate === 'function' && (
            <span onClick={(): void => props?.onUpdate?.(item.row.original)} className={className}>
              <Icons.Edit className="pointer row-action" />
            </span>
          )}
          {typeof props?.onDelete === 'function' && (
            <span onClick={(): void => props?.onDelete?.(item.row.original)} className={className}>
              <Icons.Delete className="pointer row-action" />
            </span>
          )}
        </div>
      );
    }
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CellRenderer = (props: any): JSX.Element => {
  const className = props.row.original.recordStatus === RecordStatus.GM_LOCKED && !tenantService.isGoldMaster() ? 'locked-column' : '';
  return <span className={className}>{props.value || ''}</span>;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CellJsonRenderer = (props: any): JSX.Element => {
  const className = props.row.original.recordStatus === RecordStatus.GM_LOCKED && !tenantService.isGoldMaster() ? 'locked-column' : '';
  return <span className={className}>{props.value ? JSON.stringify(props.value) : ''}</span>;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CellDateRenderer = (props: any): JSX.Element => {
  const className = props.row.original.recordStatus === RecordStatus.GM_LOCKED && !tenantService.isGoldMaster() ? 'locked-column' : '';
  return <span className={className}>{props.value ? moment(props.value as string).format('MM/DD/YYYY hh:mm:ss') : ''}</span>;
};

export const CellImageRenderer = (props: { image: string; onClick?: () => void }): JSX.Element => {
  return (
    <img
      src={props.image}
      alt="Table Button"
      width={34}
      height={34}
      className="pointer"
      onClick={props.onClick}
    />
  );
};
